import * as React from "react";
import classnames from "classnames";

const styles = require('./ErrorMessage.scss');

interface Props
{
    errorMessage?: string;
    className?: string;
}

// This components renders error messages uniformly across the app
export const ErrorMessage = ({ className, errorMessage }: Props) => (
    <span className={classnames("has-error", styles.ErrorMessage, className)}>
        <span className="control-label">{errorMessage}</span>
    </span>
);


// WEBPACK FOOTER //
// ./src/components/ErrorMessage/ErrorMessage.tsx